import React, { Component } from "react";
import { Segment, Button, Form, Message, Divider } from "semantic-ui-react";
import {CKEditor} from 'ckeditor4-react';

import request from "../../utils/request";
import { baseUrl } from "../../utils/constants";

CKEditor.editorUrl = `${baseUrl}/plugins/ckeditor/ckeditor.js`;

class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      content: "",
      xhrMessage: "",
      xhrStatus: ""
    };
  }
  componentDidUpdate = prevProps => {
    if (this.props.match !== prevProps.match) {
      this.setState({
        isLoading: true,
        content: "",
        xhrMessage: "",
        xhrStatus: ""
      }, this.fetchData);
    }
  };
  componentDidMount = () => {
    this.fetchData();
  };
  componentWillUnmount = () => {
    this.setState({
      isLoading: true,
      content: "",
      xhrMessage: "",
      xhrStatus: ""
    });
  };
  startLoading = () => {
    this.setState({ isLoading: true });
  };
  doneLoading = () => {
    this.setState({ isLoading: false });
  };
  fetchData = async () => {
    let self = this;
    self.startLoading();
    let currentPage = this.props.match.params.method;
    let page = await request.get(this, `api:/content/page/${currentPage}`, {});
    let content = (page && page.data && page.data !== "") ? page.data.trim() : "";
    self.setState({ content: content }, this.doneLoading);
  };
  handleChange = e => {
    this.setState({ content: e.editor.getData() });
  };
  handleSubmit = () => {
    this.startLoading();
    let currentPage = this.props.match.params.method;
    let payload = {
      content: this.state.content
    };
    this.setState({
      isLoading: true,
      xhrStatus: "",
      xhrMessage: ""
    });
    return request.put(this, `api:/content/page/${currentPage}`, payload).then(resp => {
      this.setState(
        {
          xhrStatus: (!resp.errors && !resp.exception) ? "success" : "error",
          xhrMessage: resp.message
        },
        this.doneLoading
      );
    });
  };
  render() {
    const { content, isLoading, xhrMessage, xhrStatus } = this.state;
    return (
      <Segment basic>
        <Form
          id="pages"
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error"}
        >
          <Message success content={xhrMessage} />
          <Message error content={xhrMessage} />
          <div style={{ textAlign: "right" }}>
            <Button
              primary
              icon="save"
              content="Save"
              onClick={this.handleSubmit}
            />
          </div>
          <Divider hidden />
          {!isLoading && (<CKEditor
            config={{
              toolbarGroups: [
                { name: 'clipboard',   groups: [ 'clipboard', 'undo' ] },
                { name: 'editing',     groups: [ 'find', 'selection' ] },
                { name: 'links' },
                { name: 'insert' },
                { name: 'forms' },
                { name: 'tools' },
                { name: 'document',	   groups: [ 'mode', 'document', 'doctools' ] },
                { name: 'others' },
                '/',
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'paragraph',   groups: [ 'list', 'indent', 'blocks', 'align' ] },
                { name: 'styles' },
                { name: 'colors' }
              ],
              removeButtons:'',
              format_tags: 'p;h1;h2;h3;pre',
              removeDialogTabs: 'image:advanced;link:advanced'
            }}
            onChange={this.handleChange}
            initData={content}
          />)}
        </Form>
      </Segment>
    );
  }
}

export default Pages;
